// extracted by mini-css-extract-plugin
export default {"table":"DataProtection_table__bjcKH","dataProtectionContent":"DataProtection_dataProtectionContent__4IPgD"};